import script from "./QModalSettingsChangeAdminPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalSettingsChangeAdminPassword.vue?vue&type=script&setup=true&lang=js"

import "./QModalSettingsChangeAdminPassword.vue?vue&type=style&index=0&id=c02f757a&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c02f757a"]])

export default __exports__